<template>
    <div class="bg-base-100">
        <div
            class="mx-auto max-w-7xl px-4 py-12 sm:pt-32 sm:px-6 lg:px-8 lg:py-40"
        >
            <div class="lg:grid lg:grid-cols-12 lg:gap-8">
                <div class="lg:col-span-5">
                    <h2
                        class="text-2xl font-bold leading-10 tracking-tight text-gray-900"
                    >
                        {{ trans("pages.faq.title") }}
                    </h2>
                    <p class="mt-4 text-base leading-7 text-gray-600">
                        {{ trans("pages.faq.subtitle") }}
                        <a
                            hreflang="nl"
                            :href="route('contact') + '#contact'"
                            class="font-semibold text-primary hover:text-indigo-500"
                        >
                            {{ trans("pages.faq.contact") }}</a
                        >. {{ trans("pages.faq.help") }}
                    </p>
                </div>
                <div class="mt-10 lg:col-span-7 lg:mt-0">
                    <dl class="space-y-10">
                        <div v-for="faq in faqs" :key="faq.question">
                            <dt
                                class="text-base font-semibold leading-7 text-gray-900"
                            >
                                {{ faq.question }}
                            </dt>
                            <dd class="mt-2 text-base leading-7 text-gray-600">
                                {{ faq.answer }}
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { trans } from "laravel-vue-i18n";
import { computed } from "vue";
const faqs = computed(() => [
    {
        question: trans("pages.faq.faq1.question"),
        answer: trans("pages.faq.faq1.answer"),
    },
    {
        question: trans("pages.faq.faq2.question"),
        answer: trans("pages.faq.faq2.answer"),
    },
    {
        question: trans("pages.faq.faq3.question"),
        answer: trans("pages.faq.faq3.answer"),
    },
    {
        question: trans("pages.faq.faq4.question"),
        answer: trans("pages.faq.faq4.answer"),
    },
    {
        question: trans("pages.faq.faq5.question"),
        answer: trans("pages.faq.faq5.answer"),
    },
    {
        question: trans("pages.faq.faq6.question"),
        answer: trans("pages.faq.faq6.answer"),
    },
    {
        question: trans("pages.faq.faq7.question"),
        answer: trans("pages.faq.faq7.answer"),
    },
    {
        question: trans("pages.faq.faq8.question"),
        answer: trans("pages.faq.faq8.answer"),
    },
    {
        question: trans("pages.faq.faq9.question"),
        answer: trans("pages.faq.faq9.answer"),
    },
    {
        question: trans("pages.faq.faq10.question"),
        answer: trans("pages.faq.faq10.answer"),
    },
]);
</script>
